import { getEntry, getNotSetValue } from 'conversations-async-data/indexed-async-data/operators/getters';
import { createSelector } from 'reselect';
import { getIndexedAsyncAssignmentStatuses } from './getIndexedAsyncAssignmentStatuses';
const getThreadIdFromProps = (__, {
  threadId
}) => threadId;
export const getAsyncAssignmentStatus = createSelector([getThreadIdFromProps, getIndexedAsyncAssignmentStatuses], (threadId, indexedAsyncAssignmentStatuses) => threadId ? getEntry(threadId, indexedAsyncAssignmentStatuses) : getNotSetValue(indexedAsyncAssignmentStatuses));